import type { Category } from '@autobid/strapi-integration/typescript/auction/categories'
import type { QueryKey, UseQueryOptions } from '@tanstack/vue-query'
import type { MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useFetchCategories } from './useFetchCategories'

type Params = {
  lang?: MaybeRef<string>
} & Omit<UseQueryOptions<Category[] | null, Error, Category[]>, 'queryKey' | 'queryFn'>

export function useCategories({ lang, ...params }: Params = {}) {
  const { locale } = useI18n()

  const langToFetch = computed(() => unref(lang ?? locale))
  const { fetchCategories } = useFetchCategories()

  const {
    data: categories,
    refetch,
    ...rest
  } = useQuery({
    queryKey: ['categories', langToFetch] as QueryKey,
    queryFn: () => fetchCategories(langToFetch.value),
    ...params,
  })

  const prefetch = async () => {
    if (!categories.value) {
      await refetch()
    }
    return categories.value
  }

  return { categories, prefetch, ...rest }
}
